var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 15.1668C14.6445 15.1668 15.1668 14.6445 15.1668 14.0002C15.1668 13.3558 14.6445 12.8335 14.0002 12.8335C13.3558 12.8335 12.8335 13.3558 12.8335 14.0002C12.8335 14.6445 13.3558 15.1668 14.0002 15.1668Z",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 6.99984C14.6445 6.99984 15.1668 6.4775 15.1668 5.83317C15.1668 5.18884 14.6445 4.6665 14.0002 4.6665C13.3558 4.6665 12.8335 5.18884 12.8335 5.83317C12.8335 6.4775 13.3558 6.99984 14.0002 6.99984Z",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 23.3333C14.6445 23.3333 15.1668 22.811 15.1668 22.1667C15.1668 21.5223 14.6445 21 14.0002 21C13.3558 21 12.8335 21.5223 12.8335 22.1667C12.8335 22.811 13.3558 23.3333 14.0002 23.3333Z",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/MoreIcon.56f09422840844206ba80bc3dda56322.svg";
export { ForwardRef as ReactComponent };